import { useEffect, useRef, useState } from 'react';
import { calculateTimeDifference } from '../utils/calculateTimeDifference';
export const useCountdown = endDate => {
  const {
    0: countdown,
    1: setCountdown
  } = useState(calculateTimeDifference(endDate));
  const intervalRef = useRef(null);
  useEffect(() => {
    intervalRef.current = setInterval(() => {
      setCountdown(calculateTimeDifference(endDate));
    }, 1000);
    return () => clearInterval(intervalRef.current);
  }, [endDate]);
  return countdown;
};